import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { NotificationItem } from './useGetNotifications';
import { useSwitchOrganization } from './useSwitchOrganization';

/**
 * Opens what a notification points at. A Yaxle employee can be tagged from a shop they
 * aren't working in; the API marks those with `otherOrganization`, and the switch has to
 * happen before the order will load.
 */
export const useOpenNotificationTarget = () => {
    const navigate = useNavigate();
    const switchOrganization = useSwitchOrganization();

    return useCallback((notification: NotificationItem, to: string, state?: unknown) => {
        const other = notification.otherOrganization;
        if (other) {
            switchOrganization.mutate({ organizationId: other.id, destination: { to, state } });
            return;
        }
        navigate(to, state ? { state } : undefined);
    }, [navigate, switchOrganization]);
};
